import * as moment from 'moment';
import {readAppConfig} from './app-config';

const MS_PER_DAY = 1000 * 60 * 60 * 24;

export class DateUtils {

    public static addDays(dt: Date, numDays: number) {
        return new Date(dt.getFullYear(), dt.getMonth(), (dt.getDate() + numDays));
    }

    public static daysDiff(a: Date, b: Date) {
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / MS_PER_DAY);
    }

    public static convertDateToStringFormat(dateValue: Date, format: string = 'YYYY-MM-DD'): string {
        return moment(dateValue).format(format);
    }

    public static convertToLocaleDateString(dateString: string, format: string = 'YYYY-MM-DD'): string {
        const as_date = this.convertToDate(dateString, format)
        const lang = this.getUsersLocale()
        const as_string = as_date.toLocaleDateString(lang, { year: 'numeric', month: '2-digit', day: '2-digit' });
        return as_string
    }

    public static convertDateTimeToLocaleString(dateValue: Date, format: string = 'YYYY-MM-DD HH:mm'): string {
        const lang = this.getUsersLocale()
        const dateString = moment(dateValue).format(format);
        const dateDate = this.convertToDate(dateString, format);
        return dateDate.toLocaleDateString(lang, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    }

    public static convertLocalDateString(dateString: string): any {
        moment.locale(this.getUsersLocale());
        const format = moment.localeData().longDateFormat('L');
        return moment(dateString, format);
    }

    public static convertLocalDateStringToDate(dateString: string): Date {
        return this.convertLocalDateString(dateString).toDate();
    }

    public static convertToDate(dateString: string, format: string = 'YYYY-MM-DD'): Date {
        return moment(dateString, format).toDate();
    }

    public static getUsersLocale(defaultValue: string = 'en-GB'): string {
        // Reached for every heat map row via convertToLocaleDateString, so an absent
        // appConfig used to break the chart before it rendered
        const configured = readAppConfig()['default_user_locale'];
        if (configured) {
            return configured;
        }
        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
            return defaultValue;
        }
        const win = window.navigator as any;
        let lang = win.languages ? win.languages[0] : defaultValue;
        lang = lang || win.language || win.browserLanguage || win.userLanguage;
        return lang;
    }
}
